<template>
  <div class="widget-section">
    <div v-if="hasBorder" class="widget-section__border"></div>
    <section class="widget-section-content">
      <header>
        <component :is="titleTag" v-if="title" class="widget-section-content__title">{{ title.label }}</component>
        <p v-if="description" class="widget-section-content__description">{{ description }}</p>
      </header>
      <aside v-if="actions" class="widget-section-content__actions">
        <ul>
          <li v-for="action of actions" :key="action.id">
            <component :is="actionComp(action.type)" v-bind="action" />
          </li>
        </ul>
      </aside>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    source: Object,
  },
  computed: {
    title() {
      if (!this.source || !this.source.title) return
      return typeof this.source.title === 'function'
        ? this.source.title({ data: this.data, source: this.source })
        : this.source.title
    },
    titleTag() {
      if (!this.source.title || !this.source.title.tag) return 'h2'
      return this.source.title.tag
    },
    description() {
      if (!this.source || !this.source.description) return
      return typeof this.source.description === 'function'
        ? this.source.description({ data: this.data, source: this.source })
        : this.source.description
    },
    hasBorder() {
      return this.source.border
    },
    actions() {
      if (!this.source || !this.source.actions) return

      return typeof this.source.actions === 'function'
        ? this.source.actions({ data: this.data, source: this.source })
        : this.source.actions
    },
  },
  methods: {
    actionComp(type) {
      switch (type) {
        case 'a':
          return 'a'
        default:
          return 'ButtonComponent'
      }
    },
  },
}
</script>

<style lang="scss">
.widget-section {
  flex-grow: 1;
  width: 100%;

  &__border {
    display: block;
    margin: 1rem 0;
    height: 1px;
    background-color: #aeb2b6;
  }
  &-content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__title {
      font-weight: 700;
      font-size: 1.6rem;
      margin: 0;
    }

    &__description {
      font-weight: 400;
      font-size: 1.2rem;
      margin: 0;
      margin-top: 1rem;
    }
    &__actions {
      ul {
        margin: 0;
        list-style: none;
      }
    }
  }
}
</style>
